import type { PaletteOptions } from '@mui/material/styles';

export const fhfPalette = (): PaletteOptions => {
  return {
    primary: {
      main: '#FFB600',
    },
    secondary: {
      main: '#3C8883',
    },
    header: {
      background: '#F7F7F8',
      color: '#2b2b2b',
    },
    menu: {
      background: '#FFB600',
      color: '#FFFFFF',
    },
    subMenu: {
      background: '#3C8883',
      color: '#FFFFFF',
    },
  };
};
